import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu as MenuIcon, Clock } from 'lucide-react';
import { usePageNavigation } from '../../lib/contexts/PageNavigationContext';
import { useLanguage } from '../../lib/i18n/LanguageContext';

const MobileBottomDock = () => {
  const { setIsCardNavOpen, setIsOpeningHoursOpen } = usePageNavigation();
  const { t } = useLanguage();

  // Set up safe area inset CSS variable
  useEffect(() => {
    document.documentElement.style.setProperty('--saib', 'env(safe-area-inset-bottom)');
    return () => {
      document.documentElement.style.removeProperty('--saib');
    };
  }, []);

  const handleMenuClick = () => {
    setIsCardNavOpen(true);
  };

  const handleOpeningHoursClick = () => {
    setIsOpeningHoursOpen(true);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] lg:hidden px-4 pb-[calc(12px+var(--saib,0px))] pt-3">
      <div className="mx-auto max-w-md rounded-2xl border border-neutral-700/60 bg-black/90 backdrop-blur supports-[backdrop-filter]:bg-black/70 shadow-lg flex items-center gap-3 px-4 py-3">
        {/* Menu Button */}
        <button
          onClick={handleMenuClick}
          aria-label="Open navigation menu"
          className="grid h-11 w-11 place-items-center rounded-xl border border-neutral-700 text-white hover:bg-neutral-800 transition-colors min-h-[44px] min-w-[44px]"
        >
          <MenuIcon className="h-5 w-5" />
        </button>

        {/* Reservations Button */}
        <button
          onClick={handleOpeningHoursClick}
          aria-label="View opening hours"
          className="grid h-11 w-11 place-items-center rounded-xl border border-neutral-700 text-white hover:bg-neutral-800 transition-colors min-h-[44px] min-w-[44px]"
        >
          <Clock className="h-5 w-5" />
        </button>

        {/* Book a Table CTA */}
        <Link
          to="/reservations"
          className="ml-auto inline-flex h-12 items-center justify-center rounded-xl border border-white/20 bg-white text-black px-5 text-sm font-semibold tracking-wide hover:bg-neutral-100 transition-colors min-h-[44px]"
          role="button"
          aria-label="Book a table at Rossopomodoro"
        >
          {t.common.nav.reservations.toUpperCase()}
        </Link>
      </div>
    </div>
  );
};

export default MobileBottomDock;
